/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgAlarm = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="m19.293 5.293 1.414 1.414-2.386 2.388a8 8 0 1 1-1.416-1.416zM12 8a6 6 0 1 0 0 12 6 6 0 0 0 0-12zm-2.293 2.293L12.415 13H16v2h-4.414l-3.293-3.293zM16 2v2H8V2z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgAlarm as Alarm };
